// @ts-check

/**
 * Function to validate sign-up email address.
 * @param {String} name Email address to be validated
 * @returns Empty string if validation passes, error message if validation failed
 */
const validateName = (name) => {
  if (!name) {
    return "validation.nameRequired";
  }
  
  return "";
};

module.exports = {
    validateName
}